'use client'
import {
  __async,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/api/section/htmlContent.ts
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var getSectionHtmlContent = (url) => __async(null, null, function* () {
  try {
    const res = yield fetch(url);
    if (!res.ok) {
      throw new Error(`Failed to fetch section html (${res.status})`);
    }
    return yield res.text();
  } catch (error) {
    throw new Exception({ error, name: "getSectionHtmlContentException" });
  }
});
var useGetSectionHtmlContent = (url, options) => {
  return useQuery(__spreadValues({
    queryKey: ["section-html", url],
    queryFn: () => getSectionHtmlContent(url),
    enabled: !!url,
    staleTime: Infinity
  }, options));
};

export {
  useGetSectionHtmlContent
};
//# sourceMappingURL=chunk-E42MQMXB.mjs.map